// language-selector.js

export const initLanguageSelector = () => {
  const form = document.querySelector('#languageSelector form');
  const countrySelect = document.getElementById('countrySelect');
  const languageSelect = document.getElementById('languageSelect');

  if (!form) {
    return;
  }

  function handleChange() {
    form.submit();
  }

  if (countrySelect) {
    countrySelect.addEventListener('change', handleChange);
  }

  if (languageSelect) {
    languageSelect.addEventListener('change', handleChange);
  }
};
